import { useId } from 'react';
import Markdown from 'react-markdown';

import type { GDPRTranslations } from '../types';

interface Props {
  hasCustomTermsOfService?: string;
  customTermsOfServiceText?: string;
  defaultTOSConsentValue: boolean;
  gdprTranslations?: GDPRTranslations;
}

export const SignupGDPRCompliance = ({
  hasCustomTermsOfService,
  customTermsOfServiceText,
  defaultTOSConsentValue,
  gdprTranslations = {
    consentText: 'I consent to receive newsletters via email.',
    termsOfUseText: 'Terms of Use',
    privacyPolicyText: 'Privacy Policy',
    andText: 'and',
    consentTextVariantTwo: 'I consent to receive newsletters via Email. Signup',
    termsOfServiceText: 'Terms of Service',
  },
}: Props) => {
  const hasCustomText = Boolean(customTermsOfServiceText?.trim());
  const consentTextId = useId();

  return (
    <div className="flex w-full flex-row items-start space-x-2">
      <input
        type="checkbox"
        name="tos_consent"
        className="h-4 w-4 rounded border-gray-300 mt-0.5"
        defaultChecked={hasCustomText ? false : defaultTOSConsentValue}
        required={hasCustomText}
        aria-labelledby={consentTextId}
        style={{
          accentColor: 'var(--gdpr-checkbox-color)',
        }}
      />
      {hasCustomText ? (
        <div
          id={consentTextId}
          className="text-xs text-start font-medium [&_a]:underline [&_a]:underline-offset-1 [&_a:hover]:opacity-80"
          style={{
            color: 'var(--gdpr-text-color)',
          }}
        >
          <Markdown
            allowedElements={['p', 'a', 'strong', 'em']}
            unwrapDisallowed
            components={{
              a: ({ node: _node, ...props }) => (
                <a
                  {...props}
                  target="_blank"
                  rel="noreferrer"
                  style={{ textDecorationColor: 'var(--gdpr-text-color)' }}
                />
              ),
              p: ({ node: _node, ...props }) => <p {...props} />,
            }}
          >
            {customTermsOfServiceText}
          </Markdown>
        </div>
      ) : !hasCustomTermsOfService ? (
        <p
          id={consentTextId}
          className="text-xs text-start font-medium"
          style={{
            color: 'var(--gdpr-text-color)',
          }}
        >
          {gdprTranslations.consentText}{' '}
          <a
            href="https://www.beehiiv.com/tou"
            target="_blank"
            className="underline underline-offset-1 hover:opacity-80"
            rel="noreferrer"
            style={{
              textDecorationColor: 'var(--gdpr-text-color)',
            }}
          >
            {gdprTranslations.termsOfUseText}
          </a>{' '}
          {gdprTranslations.andText}{' '}
          <a
            href="https://www.beehiiv.com/privacy"
            target="_blank"
            className="underline underline-offset-1 hover:opacity-80"
            rel="noreferrer"
            style={{
              textDecorationColor: 'var(--gdpr-text-color)',
            }}
          >
            {gdprTranslations.privacyPolicyText}
          </a>
          .
        </p>
      ) : (
        <p
          id={consentTextId}
          className="text-xs text-start font-medium"
          style={{
            color: 'var(--gdpr-text-color)',
          }}
        >
          {gdprTranslations.consentTextVariantTwo}{' '}
          <a
            href={hasCustomTermsOfService}
            target="_blank"
            className="underline underline-offset-1 hover:opacity-80"
            rel="noreferrer"
            style={{
              textDecorationColor: 'var(--gdpr-text-color)',
            }}
          >
            {gdprTranslations.termsOfServiceText}
          </a>
          .
        </p>
      )}
    </div>
  );
};
